<template>
  <div>
    <Splitter style="border:none;" >
      <SplitterPanel class="flex items-center justify-center" :minSize="50" >
        <div class="flex flex-wrap gap-4 p-fluid" style="padding-right:20px;">
          <Tag severity="info" :value="$t('menu.buyAgentFee')"/>
          <Select class="input-margin" v-model="country" 
            :options="[...this.api.COUNTRIES].sort((a, b) => a.name.localeCompare(b.name, 'ko'))" 
            optionLabel="name" 
            filter 
            filterBy="name" 
            showClear 
            placeholder="Select a Country" 
            style="width:100%;" 
            @change="change" >

            <template #value="slotProps">
              <div v-if="slotProps.value" class="flex items-center gap-2">
                <img src="https://primefaces.org/cdn/primevue/images/flag/flag_placeholder.png" 
                    :class="`flag flag-${slotProps.value.code.toLowerCase()}`" 
                    style="width: 18px;margin-right:10px;" />
                {{ slotProps.value.name }} (+{{ slotProps.value.phone }})
              </div>
              <span v-else>{{ slotProps.placeholder }}</span>
            </template>
            <template #option="slotProps">
              <div class="flex items-center gap-2">
                <img src="https://primefaces.org/cdn/primevue/images/flag/flag_placeholder.png" 
                    :class="`flag flag-${slotProps.option.code.toLowerCase()}`" 
                    style="width: 18px;margin-right:10px;" />
                {{ slotProps.option.name }} (+{{ slotProps.option.phone }})
              </div>
            </template>

          </Select>
          <FloatLabel class="flex justify-center input-margin" >
            <InputNumber id="fPrice"  v-model="fPrice" :min="0" size="small" :minFractionDigits="2" :currency="currency"  mode="currency" v-tooltip.:right="$t('sentence.descFprice')" />
            <label for="fPrice" >{{ $t('menu.fPrice') }}</label>
          </FloatLabel>
          <FloatLabel class="flex justify-center input-margin" >
            <InputNumber id="dPrice" v-model="dPrice" :min="0" size="small" :minFractionDigits="2" :currency="currency"  mode="currency" v-tooltip.:right="$t('sentence.descDprice')" />
            <label for="dPrice" >{{ $t('menu.lPrice') }}</label>
          </FloatLabel>
          <FloatLabel class="flex justify-center input-margin" >
            <InputNumber id="ePrice" v-model="ePrice" :min="0" size="small" :minFractionDigits="2" :currency="currency"  mode="currency" v-tooltip.:right="$t('sentence.descEprice')"/>
            <label for="ePrice" >{{ $t('menu.ePrice') }}</label>
          </FloatLabel>
          <br><br>
          <div class="tooltip e_values" v-tooltip.:right="$t('menu.estimatedBuyFee')">{{ $t('menu.estimatedBuyFee') }} <div class="e_price" id="e_val1"></div>
          </div>
          <span class="status_cnt">
            <Button @click="calcPrice(0)" :label="$t('menu.calc')" raised size="small" />
          </span>
        </div>
      </SplitterPanel>
      <SplitterPanel class="flex items-center justify-center" :minSize="50" > 
        <div class="flex flex-wrap gap-4 p-fluid" style="padding-left:20px;">
          <Tag severity="info" :value="$t('menu.deliverAgentFee')"/>
          <FloatLabel class="flex justify-center input-margin" >
            <InputNumber id="horizon" v-model="horizon" :min="0" size="small" :minFractionDigits="2" v-tooltip.:left="$t('sentence.descHeight')"/>
            <label for="horizon" >{{$t('unit.width')}}(mm)</label>
          </FloatLabel>
          <FloatLabel class="flex justify-center input-margin" >
            <InputNumber id="vertical" v-model="vertical" :min="0" size="small" :minFractionDigits="2" v-tooltip.:left="$t('sentence.descVertical')"/>
            <label for="vertical" >{{$t('unit.length')}}(mm)</label>
          </FloatLabel>
          <FloatLabel class="flex justify-center input-margin" >
            <InputNumber id="height" v-model="height" :min="0" size="small" :minFractionDigits="2" v-tooltip.:left="$t('sentence.descHeight')"/>
            <label for="height" >{{$t('unit.height')}}(mm)</label>
          </FloatLabel>
          <FloatLabel class="flex justify-center input-margin" >
            <InputNumber id="weight" v-model="weight" :min="0" size="small" :minFractionDigits="2" v-tooltip.:left="$t('sentence.descWeight')"/>
            <label for="weight" >{{$t('unit.weight')}}(g)</label>
          </FloatLabel>
        <br>
        <br>
        <div class="tooltip e_values" v-tooltip.:top="$t('sentence.descEstimatedDeliveryFee')">
          {{ $t('menu.estimatedDeliveryFee') }} 
          <div class="e_price" id="e_val2"></div>
        </div>
        <span class="status_cnt">
          <Button @click="calcPrice(1)" :label="$t('menu.calc')" raised size="small" />
        </span>
      </div>
      </SplitterPanel>
    </Splitter>
  </div> 
</template>
<script>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

export default {
  setup() {
    const { t } = useI18n()
    const country = ref()
    return {
       country, t
    }
  },
  data() {
    return {
      currency:"HKD",
      horizon:null,
      vertical:null,
      height:null,
      weight:null,
      fPrice:null,
      dPrice:null,
      ePrice:null,
    }
  },
  methods: {
    change() {
      document.getElementById("e_val1").innerHTML = ""
      this.currency = this.country.currency 
    },
    async calcPrice(type) {
      if(type === 0) {
        const countryCode = this.country.name + '환율'
        if(countryCode === '' || this.fPrice === '' || this.dPrice === '' || this.ePrice === '' || countryCode === undefined || this.fPrice === null || this.dPrice === null || this.ePrice === null) {
          alert(`${this.t('sentence.emptyField')}`)
        } else {
          this.emitter.emit('dialog', {flag:true, title:'loading'})
          const param = {type: 'calcBuy', country: countryCode, sellPrice: this.fPrice, delivery: this.dPrice, etc: this.ePrice}
          await this.api.axiosGql('calcBuy', param) 
          .then((res) => {
            let won = res.data.result
            won = parseInt(won.toString()).toLocaleString()
            document.getElementById("e_val1").innerHTML = won + this.t('unit.won')
          }) 
          .catch((error) => { 
            console.log(error)
          }) 
          .finally(() => { 
            this.emitter.emit('dialog', {flag:false, title:'loading'})
          })
        }
      } else if(type === 1) {
        if(this.horizon === '' || this.vertical == '' || this.height == '' || this.weight == '' || this.horizon === null || this.vertical == null || this.height == null || this.weight == null ) {
          alert(`${this.t('sentence.emptyField')}`)
        } else {
          alert(`${this.t('sentence.warnEstimate')}`)
          this.emitter.emit('dialog', {flag:true, title:'loading'})
          const param = {'type': 'calcDelivery', 'horizon': this.horizon/10, 'vertical': this.vertical/10, 'height': this.height/10, 'weight': this.weight/1000}
          await this.api.axiosGql('calcDelivery', param) 
          .then((res) => { 
            let won = res.data.result
            won = parseInt(won.toString()).toLocaleString()
            document.getElementById("e_val2").innerHTML =  won + `${this.t('unit.won')}`
          }) 
          .catch((err) => { console.log(err) }) 
          .finally(() => { 
            this.emitter.emit('dialog', {flag:false, title:'loading'})
          });
        }
      }
    },
    changeCountry(event) {
      var currency = ''
      switch(event.target.value) {
        case '유로환율':
          currency = 'EUR'
          break
        case '홍콩환율':
          currency = 'HKD'
          break
        case '영국환율':
          currency = 'GBP'
          break          
        case '일본환율':
          currency = 'JPY'
          break
        case '중국환율':
          currency = 'CNY'
          break
        case '미국환율':
          currency = 'USD'
          break
        case '싱가포르환율':
          currency = 'SGD'
          break
        case '호주환율':
          currency = 'AUD'
          break
        case '아이슬란드환율':
          currency = 'ISK'
          break
        case '필리핀환율':
          currency = 'PHP'
          break
        case '인도네시아환율':
          currency = 'IDR'
          break        
        case '인도환율':
          currency = 'INR'
          break
        case '루마니아환율':
          currency = 'RON'
          break
        case '뉴질랜드환율':
          currency = 'NZD'
          break
        case '브라질환율':
          currency = 'BRL'
          break
        case '덴마크환율':
          currency = 'DKK'
          break
        case '캐나다환율':
          currency = 'CAD'
          break
        case '대만환율':
          currency = 'TWD'
          break
        case '헝가리환율':
          currency = 'HUF'
          break
        case '폴란드환율':
          currency = 'PLN'
          break
        case '태국환율':
          currency = 'THB'
          break
        case '베트남환율':
          currency = 'VND'
          break
        case '세르비아환율':
          currency = 'RSD'
          break
        case '스웨덴환율':
          currency = 'SEK'
          break
        case '체코환율':
          currency = 'CZK'
          break
        case '멕시코환율':
          currency = 'MXN'
          break
      }
      this.currencyPlaceHolder(currency)
    },
    currencyPlaceHolder(currency) {
      this.$refs.f_price.placeholder = currency
      this.$refs.d_price.placeholder = currency
      this.$refs.e_price.placeholder = currency
    }
  }
}
</script>

<style scoped>
.e_price {
  color: red;
}
</style>